import { GridActionsCellItem, type GridRowParams } from "@mui/x-data-grid";
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import type { WaTemplateSetup } from "features/waMessaging/types";
import { useWaTemplateSetupContext } from "./WaTemplateSetupProvider";

const useRowActions = () => {
    const { openView, openEdit } = useWaTemplateSetupContext();

    return ({ row }: GridRowParams<WaTemplateSetup>) => [
        <GridActionsCellItem
            key='view'
            onClick={() => openView(row)}
            icon={<VisibilityIcon />}
            label='View'
            data-test-id={`waTemplatesSetups.table.row.${row.coreId}.actions.view`}
        />,
        <GridActionsCellItem
            key='edit'
            onClick={() => openEdit(row)}
            icon={<EditIcon />}
            label='Edit'
            data-test-id={`waTemplatesSetups.table.row.${row.coreId}.actions.edit`}
        />
    ];
};

export default useRowActions;
